export default "/_next/static/images/bd2eea3b876a1b3812b69b71cc91f228.jpg";